import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getUser, getClDomain, translate, getCashStatus } from '../../utils/Common';
// contexts
import AuthContext from "../../contexts/auth";
import SidebarContext from "../../contexts/sidebar";
import Skeleton from '../ui/Skeleton';
// icons
import * as FaIcons from 'react-icons/fa';
import * as BsIcons from 'react-icons/bs';
import * as RiIcons from 'react-icons/ri';
import './index.css';
import { useCashStatus } from '../../contexts/cash';
import { useCash } from '../../hooks/useCash';
import NotifyC from "../Notifications"

const Navbar = () => {
  const { getCashBoxStatus } = useCash();
  const userContext = useContext(AuthContext);
  const sidebarContext = useContext(SidebarContext);
  const { cashStatus } = useCashStatus();
  const [isMenuProfileOpen, setIsMenuProfileOpen] = useState(false);
  const [cajaStatus, setCajaStatus] = useState(null);
  const user = getUser();
  let menuRef = useRef();

  const handleGetinfoCashBox = async () => {
    const abortController = new AbortController();
    const response = await getCashBoxStatus(abortController.signal);
    if (response?.cajas?.length > 0 && response.cajas[0].EstatusCaja > 0) {
      const status = getCashStatus(response.cajas[0].EstatusCaja);
      setCajaStatus(status); 
    } else {
       setCajaStatus(getCashStatus(0)); 
    } 
  };

  useEffect(() => {
    const handlerCloseMenuProfile = (e) => !menuRef.current.contains(e.target) && setIsMenuProfileOpen(false);

    document.addEventListener("mousedown", handlerCloseMenuProfile);

    return () => document.removeEventListener("mousedown", handlerCloseMenuProfile);
  }, []);

  useEffect(() => {
    handleGetinfoCashBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`d-flex justify-content-between shadow-sm nav${!sidebarContext.sidebarOpen ? '-close' : ''}`}
      style={getClDomain() !== 'cotel.myboxit.com' ? { top: '22px' } : { top: '0px' }}>
      <div className="bars-div" onClick={() => sidebarContext.showSidebar(!sidebarContext.sidebarOpen)}>
        <FaIcons.FaBars className="bars" size={25} />
      </div>

      <div className="d-flex align-items-center">
        <div className="mr-1">
          {/* Priorizar cashStatus */}
          {user.roleId < 2 && (
            cashStatus ? (
              <div
                style={{
                  color: "white",
                  background: cashStatus.color,
                  padding: "0.5rem 1rem",
                  fontWeight: "bold",
                  borderRadius: "1rem",
                }}
              >
                <span>
                  {cashStatus.icon}{" "}
                  {/* {cashStatus.text} */}
                </span>
              </div>
            ) : cajaStatus ? (
              <div
                style={{
                  color: "white",
                  background: getCashStatus(cajaStatus?.id)?.color,
                  padding: "0.5rem 1rem",
                  fontWeight: "bold",
                  borderRadius: "1rem",
                }}
              >
                <span>
                  {getCashStatus(cajaStatus?.id)?.icon}{" "}
                </span>
              </div>
            ) : (
              <Skeleton
                variant="rectangular"
                width="45px"
                height="35px"
                borderRadius="16px"
              />
            )
          )}
        </div>

        {/* Menú de usuario */}
        <div ref={menuRef} className={"user-section" + (isMenuProfileOpen ? " active" : "")} onClick={() => setIsMenuProfileOpen(!isMenuProfileOpen)}>
          <div className="d-flex align-items-center justify-conetnt-center">
            <BsIcons.BsPersonCircle className="user" size={25} />
            <p className="username text-uppercase">
              {user?.Usuario ? user?.Usuario : 'usuario'}
            </p>
            {isMenuProfileOpen ? <RiIcons.RiArrowUpSFill className="menu-arrow" /> : <RiIcons.RiArrowDownSFill className="menu-arrow" />}
          </div>
          <ul className="dropdown-user">
            <li className="nav-option"><Link className="user-option-text" to="/dashboard/profile/" >Mi Perfil</Link></li>
            <li className="nav-option"><Link className="user-option-text" to="/login" onClick={() => userContext.signOut()}>Cerrar Sesión</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Navbar;